var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resumo-padrao',{ref:"resumo",attrs:{"resumo-proposta":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }